import { store } from '@utils/configStore'
import { chargeManagementReducer } from './slice'

export const injectChargeManagement = () => store.injectReducer('chargeManagement', chargeManagementReducer)
